import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FiscalDocumentService {

  private URL = environment.api + "api/erp/fiscal-document";

  constructor(private http: HttpClient) { }

  generateFiscalDocument(request) {
		return this.http.post(this.URL + `/generate`, request);
	}
}
